import gql from 'graphql-tag';
export default gql`
  mutation UpdateLinkById($input: UpdateLinkByIdInput!) {
    updateLinkById(input: $input) {
      clientMutationId
    }
  }
`;
